import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.grey[100],
    width: '100%',
    borderRadius: 8,
    marginBottom: 16
  },
  gatewayContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  },

  header: {
    padding: '16px'
  },
  headerTitle: {
    color: theme.palette.text.primary,
    marginBottom: 16,
    marginLeft: 8
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },
  divider: { marginBottom: '10px' },
  content: {
    padding: '0px 16px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  radioGroup: {},
  options: {
    padding: '8px 8px',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    margin: '4px 0px'
  },
  optionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  selectedOption: { background: theme.palette.background.default },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 16px'
  },
  confirmBtn: {
    width: '100%',
    margin: '8px 0px',
    padding: 8,
    background: theme.palette.grey[400],
    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    }
  },
  selectedConfirmBtn: {
    background: theme.palette.secondary.main
  },
  peymentIcon: { color: theme.palette.primary.contrastText },
  backBtn: { padding: 8 },

  whiteText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    alignSelf: 'center'
  },
  blackText: { fontWeight: 500 },
  banksContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  radioRoot: {
    '& svg': { fontSize: '14px' }
  },
  bank: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    padding: 4,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    },
    margin: 4
  },
  bankSelected: {
    border: `1px solid ${theme.palette.text.primary}`,
    backgroundColor: theme.palette.grey[100]
  },
  bankIcon: {
    width: 56,
    height: 56
  },
  bankLabel: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    fontSize: 12
  },
  balanceContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 8,
    borderRadius: 8,
    background: theme.palette.grey[200]
  },
  balanceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 4px',
    background: theme.palette.grey[200]
  },
  text: { fontWeight: 500, color: theme.palette.text.primary },
  greyText: {
    fontWeight: 500,
    color: theme.palette.grey[600],
    verticalAlign: 'middle'
  },
  formControl: {
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
      fontWeight: 500,
      color: theme.palette.text.primary
    }
  },
  dashedDivider: {
    borderBottom: '0.5px dashed'
  },
  infoIcon: { fontSize: 16, marginRight: 4, color: theme.palette.grey[600] },
  iconTextRow: {
    display: 'flex',
    flexDirection: 'row',
    background: theme.palette.grey[200],
    padding: 8
  },
  boldtext: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    margin: '16px 0'
  },
  circularProgress: {
    marginBottom: -4,
    marginLeft: 8,
    color: theme.palette.background.default
  },
  confirmBtnDisabled: { background: theme.palette.grey[400] }
}))
